import React from 'react';
import { FormControl, FormLabel, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { useFormikContext } from 'formik';
import { RENEWAL_DATE } from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { RENEWAL_DATE_HELP_TEXT } from '@/utils/helperText';

const RenewalDateField = () => {
	const { values, isSubmitting, setFieldValue } = useFormikContext();

	return (
		<FormControl fullWidth>
			<FormLabel>{'Renewal date'}</FormLabel>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DatePicker
					name={RENEWAL_DATE}
					sx={{ width: '100%' }}
					disabled={isSubmitting}
					format='dd/MM/yyyy'
					value={values.renewalDate}
					onChange={(value) => {
						setFieldValue(RENEWAL_DATE, value);
					}}
				/>
			</LocalizationProvider>
			<FormHelperText>{RENEWAL_DATE_HELP_TEXT}</FormHelperText>
		</FormControl>
	);
};

export default RenewalDateField;
